// extracted by mini-css-extract-plugin
export default {"InputDisplayOnly":"InputDisplayOnly_InputDisplayOnly__EXf0R","value":"InputDisplayOnly_value__KcJBm"};